
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as PrismicPreviewUaEZXDnwK9Meta } from "/codebuild/output/src1502099463/src/frontend-corporate-website/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue?macro=true";
import { default as _91uid_930vnX8JIyfyMeta } from "/codebuild/output/src1502099463/src/frontend-corporate-website/pages/[uid].vue?macro=true";
import { default as indexOmJF9JDzxSMeta } from "/codebuild/output/src1502099463/src/frontend-corporate-website/pages/index.vue?macro=true";
import { default as slice_45simulator1FkWoegNjVMeta } from "/codebuild/output/src1502099463/src/frontend-corporate-website/pages/slice-simulator.vue?macro=true";
export default [
  {
    name: "prismic-preview",
    path: "/preview",
    component: () => import("/codebuild/output/src1502099463/src/frontend-corporate-website/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue")
  },
  {
    name: "uid",
    path: "/:uid()",
    component: () => import("/codebuild/output/src1502099463/src/frontend-corporate-website/pages/[uid].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1502099463/src/frontend-corporate-website/pages/index.vue")
  },
  {
    name: "slice-simulator",
    path: "/slice-simulator",
    component: () => import("/codebuild/output/src1502099463/src/frontend-corporate-website/pages/slice-simulator.vue")
  }
]